export class VersionService {
    version:string = "1500";

    getVersion(): string {
        return this.version;
    }
}
